import * as C from "../constants";

import { get_invalid_keys, get_keys, post_key, put_key, delete_key, get_key_types, get_key, get_key_transactions } from "utils/http";
import { parseJSON } from "utils/misc";
import { logout } from "./auth";
import { history } from "../history";

export function getInvalidKeysRequest() {
    return {
        type: C.INVALID_KEYS_REQUEST,
    };
}

export function getInvalidKeysFailure() {
    return {
        type: C.INVALID_KEYS_FAILURE,
    }
}

export function getInvalidKeysSuccess(data) {
    return {
        type: C.INVALID_KEYS_SUCCESS,
        payload: data,
    }
}

export function getKeysRequest() {
    return {
        type: C.GET_KEYS_REQUEST,
    }
}

export function getKeysFailure() {
    return {
        type: C.GET_KEYS_FAILURE,
    }
}

export function getKeysSuccess(data) {
    return {
        type: C.GET_KEYS_SUCCESS,
        payload: data
    }
}

export function createKeySuccess(key) {
    return {
        type: C.CREATE_KEY,
        payload: key,
    }
}

export function createKeyFailure() {
    return {
        type: C.CREATE_KEY_FAILURE,
    }
}

export function editKeySuccess(key) {
    return {
        type: C.EDIT_KEY,
        payload: key,
    }
}

export function editKeyFailure() {
    return {
        type: C.EDIT_KEY_FAILURE
    }
}

export function deleteKeySuccess(id) {
    return {
        type: C.DELETE_KEY,
        payload: id
    }
}

export function deleteKeyFailure() {
    return {
        type: C.DELETE_KEY_FAILURE,
    }
}

export function getKeyTypesRequest() {
    return {
        type: C.GET_KEY_TYPES_REQUEST,
    }
}

export function getKeyTypesFailure() {
    return {
        type: C.GET_KEY_TYPES_FAILURE,
    }
}

export function getKeyTypesSuccess(data) {
    return {
        type: C.GET_KEY_TYPES_SUCCESS,
        payload: data,
    }
}

export function getKeyRequest() {
    return {
        type: C.GET_KEY_REQUEST,
    }
}

export function getKeyFailure() {
    return {
        type: C.GET_KEY_FAILURE,
    }
}

export function getKeySuccess(data) {
    return {
        type: C.GET_KEY_SUCCESS,
        payload: data,
    }
}

export function getKeyTransactionsRequest() {
    return {
        type: C.GET_KEY_TRANSACTION_REQUEST,
    }
}

export function getKeyTransactionsFailure() {
    return {
        type: C.GET_KEY_TRANSACTION_FAILURE,
    }
}

export function getKeyTransactionsSuccess(data) {
    return {
        type: C.GET_KEY_TRANSACTION_SUCCESS,
        payload: data,
    }
}

export function getInvalidKeys(token, page, rows_per_page) {
    return function (dispatch) {
        dispatch(getInvalidKeysRequest());
        return get_invalid_keys(token, page, rows_per_page)
            .then(parseJSON)
            .then(response => {
                try {
                    dispatch(getInvalidKeysSuccess(response));
                } catch (e) {
                    dispatch(getInvalidKeysFailure());
                }
        }).catch(error => {
            dispatch(getInvalidKeysFailure());
            if (error.response && error.response.status === 401) {
                dispatch(logout());
                history.replace("/login");
            }
        })
    }
}

export function getKeys(token, page, rows_per_page, search_query, type) {
    return function (dispatch) {
        dispatch(getKeysRequest());
        return get_keys(token, page, rows_per_page, search_query, type)
            .then(parseJSON).then(response => {
                dispatch(getKeysSuccess(response))
            }).catch(error => {
                dispatch(getKeysFailure());
                if (error.response && error.response.status === 401) {
                    dispatch(logout());
                    history.replace("/login");
                }
            })
    }
}

export function createKey(token, key) {
    return function (dispatch) {
        return post_key(token, key)
            .then(parseJSON).then(response => {
                dispatch(createKeySuccess(response));
                return response;
            }).catch(error => {
                dispatch(createKeyFailure());
                if (error.response && error.response.status === 401) {
                    dispatch(logout());
                    history.replace("/login");
                }
            })
    }
}

export function editKey(token, key) {
    return function (dispatch) {
        return put_key(token, key)
            .then(parseJSON).then(response => {
                dispatch(editKeySuccess(response));
                return response;
            }).catch(error => {
                dispatch(editKeyFailure());
                if (error.response && error.response.status === 401) {
                    dispatch(logout());
                    history.replace("/login");
                }
            })
    }
}

export function deleteKey(token, id) {
    return function (dispatch) {
        return delete_key(token, id)
            .then(parseJSON).then(response => {
                dispatch(deleteKeySuccess(response));
                console.log(typeof response);
                return response;
            }).catch(error => {
                dispatch(deleteKeyFailure());
                if (error.response && error.response.status === 401) {
                    dispatch(logout());
                    history.replace("/login");
                }
            })
    }
}

export function getKeyTypes(token) {
    return function (dispatch) {
        dispatch(getKeyTypesRequest());
        return get_key_types(token)
            .then(parseJSON).then(response => {
                dispatch(getKeyTypesSuccess(response))
            }).catch(error => {
                dispatch(getKeyTypesFailure());
                if (error.response && error.response.status === 401) {
                    dispatch(logout());
                    history.replace("/login");
                }
            })
    }
}

export function getKey(token, key_id) {
    return function (dispatch) {
        dispatch(getKeyRequest());
        return get_key(token, key_id)
            .then(parseJSON).then(response => {
                dispatch(getKeySuccess(response))
            }).catch(error => {
                dispatch(getKeyFailure());
                if (error.response && error.response.status === 401) {
                    dispatch(logout());
                    history.replace("/login");
                }
            })
    }
}

export function getKeyTransactions(token, key_id, page, rows_per_page) {
    return function (dispatch) {
        dispatch(getKeyTransactionsRequest());
        return get_key_transactions(token, key_id, page, rows_per_page)
            .then(parseJSON).then(response => {
                dispatch(getKeyTransactionsSuccess(response));
            }).catch(error => {
                dispatch(getKeyTransactionsFailure());
                if (error.response && error.response.status === 401) {
                    dispatch(logout());
                    history.replace("/login");
                }
            })
    }
}


// WEBPACK FOOTER //
// ./src/actions/keys.js